export default "__VITE_ASSET__c6aed5a8__"